module.exports = __webpack_public_path__ + "static/media/isogeio.48834f09.jpg";